export default __webpack_public_path__ + "static/media/icon_twitter.fe8a029c.svg";